import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AcceptInviteComponent } from './accept-invite.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
    { path: 'accept-invite/:token', component: AcceptInviteComponent },
])
  ],
  exports: [RouterModule]
})
export class AcceptInviteRoutingModule { }
